<ion-header>
    <ion-toolbar [color]="_pg.workingOffline ? 'colorTemaOffline' : 'colorTema1'">
        <ion-buttons slot="start">
            <ion-button class="back-button bar-button bar-button-md back-button-md bar-button-default bar-button-default-md show-back-button" (click)="cerrarSinParametros()">
              <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>{{'txSeleccionarMaterial' | translate}}</ion-title>
        <!-- <ion-buttons end>
            <button ion-button icon-only (click)="cerrarConParametros()">
              <ion-icon name="lc-icon-check"></ion-icon>
          </button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-searchbar class="search-bar " [placeholder]="'txBuscar' | translate" slot="fixed" (search)="onInput($event)" [(ngModel)]="valorSearch"></ion-searchbar>
    <ion-list class="contenido">
        <ion-item *ngFor="let mat of materiales" (click)="cerrarConParametros(mat)">
          <ion-label>
            <p>{{ (mat.codi > '')? mat.codi + " - " + mat.descripcio: mat.descripcio}}</p>
          </ion-label>
        </ion-item>
    </ion-list>

    <label *ngIf="materiales.length==0 && consultaWSRealizada" class="text-no-existe">{{'txMaterialesNoEncontrados' | translate}}</label>

    <ion-infinite-scroll (ionInfinite)="doInfinite($event) " [disabled]="!hayMasElementos">
        <ion-infinite-scroll-content></ion-infinite-scroll-content>
    </ion-infinite-scroll>
    <label *ngIf="!hayMasElementos" class="ion-float-right text-no-existe">{{'txMaterialesNoMasElementos' | translate}}</label>
</ion-content>
